var initialNavOffset = 0;

// Sticky Navigation
$(window).on( 'scroll', function(){
  if ($(window).scrollTop() >= initialNavOffset) {
    $('.nav').addClass('js-sticky');
    $(".wrapper__body").css("padding-top", $('.nav__bar').outerHeight());
  } else {
    $('.nav').removeClass('js-sticky');
    $(".wrapper__body").css("padding-top", 0);
  }
});



// Initialize Headroom.js (but not when mobile nav is open)
function isNavOpen(nav) {
  return ( nav.hasClass('js-nav-active') ? true : false );
}
var headroom = new Headroom(document.querySelector('.nav'), {
  offset: 1200,
  tolerance: 50,
  onUnpin: function() {
    if ( isNavOpen($('.nav__wrapper')) ) {
      this.elem.classList.remove(this.classes.unpinned);
      this.elem.classList.add(this.classes.pinned);
    }
    else {
      this.elem.classList.add(this.classes.unpinned);
      this.elem.classList.remove(this.classes.pinned);
    }
  }
});
headroom.init();


// set height of header wrapper and margin-top of body wrapper
function resizeHeader() {
  var headerHeight = 0;
  $(".wrapper__header").children().each(function(){
      headerHeight += $(this).outerHeight();
  });
  $(".wrapper__header").css("height", headerHeight);
  $(".wrapper__body").css("margin-top", headerHeight);
}


$(window).on('load resize', function(){
  resizeHeader();
  initialNavOffset = $('.nav').offset().top;
})

$('.slider__news').on('afterChange', function(){
  resizeHeader()
});



// WEBPACK FOOTER //
// ./assets/js/features/header.js